import React from "react"
import "./details.css"
import Gallery from "react-amazon-gallery"
import PLACEHOLDER_IMAGE from "../utils/placeholder"

const Details = (props) => {
  let images = (props.images || [])
    .filter((img) => img?.file?.url)
    .map((img) => img.file.url)
  if (images.length === 0) images = [PLACEHOLDER_IMAGE]

  let objImages = {}
  objImages.orientation = "horizontal"
  objImages.overlay = false
  objImages.size = 60
  objImages.bkgSize = "cover"
  objImages.posX = "center"
  objImages.posY = "center"
  objImages.height = "500px"
  objImages.width = "100%"

  const formatPrice = (price) => {
    if (!price && price !== 0) return null
    return new Intl.NumberFormat("es-MX", {
      style: "currency",
      currency: "MXN",
      minimumFractionDigits: 0,
    }).format(price)
  }

  return (
    <div className="Details">
      <div className="DetailsGroup">
        <div className="DetailsGallery">
          <Gallery images={images} main={objImages} />
        </div>
        <div className="DetailsInfo">
          {props.badge && <span className="DetailsBadge">{props.badge}</span>}
          {props.descuento > 0 && (
            <span className="DetailsDiscountBadge">-{props.descuento}%</span>
          )}
          <h2 className="DetailsTitle">{props.title}</h2>
          {props.precio != null && (
            <div className="DetailsPriceContainer">
              {props.descuento > 0 ? (
                <>
                  <span className="DetailsPrice DetailsPriceOriginal">
                    {formatPrice(props.precio)}
                  </span>
                  <span className="DetailsPrice DetailsPriceDiscount">
                    {formatPrice(
                      Math.round(props.precio * (1 - props.descuento / 100))
                    )}
                  </span>
                </>
              ) : (
                <span className="DetailsPrice">
                  {formatPrice(props.precio)}
                </span>
              )}
              <span className="DetailsPriceLabel">MXN</span>
            </div>
          )}
          <div className="DetailsDivider"></div>
          <div className="DetailsDescription">{props.description}</div>
          {(props.marca || props.categoria) && (
            <div className="DetailsSpecs">
              {props.marca && (
                <span className="DetailsSpecItem">
                  <strong>Marca:</strong> {props.marca}
                </span>
              )}
              {props.categoria && (
                <span className="DetailsSpecItem">
                  <strong>Categoría:</strong> {props.categoria}
                </span>
              )}
            </div>
          )}
          {Array.isArray(props.especificaciones) &&
            props.especificaciones.length > 0 && (
              <div className="DetailsNotas">
                <h4 className="DetailsNotasTitle">Especificaciones</h4>
                {props.especificaciones.map((esp, i) => (
                  <p className="DetailsNotasRow" key={i}>
                    <strong>{esp.etiqueta}:</strong> {esp.valor}
                  </p>
                ))}
              </div>
            )}
          {props.children && (
            <div className="DetailsActions">{props.children}</div>
          )}
        </div>
      </div>
    </div>
  )
}

export default Details
